import { Component, Input, OnInit } from '@angular/core';
import { SystemNotificationService } from '../../../core/services/system-notification.service';

@Component({
  selector: 'th-unread-notification-count',
  templateUrl: './unread-notification-count.component.html',
  styleUrls: ['./unread-notification-count.component.scss']
})
export class UnreadNotificationCountComponent implements OnInit {
  @Input() hideText = false;
  unreadNotificationCount = 0;

  constructor(private systemNotificationService: SystemNotificationService) {}

  ngOnInit() {
    this.systemNotificationService.notificationCountUpdated.subscribe((count) => this.setCount(count));
  }

  private setCount(count: number) {
    this.unreadNotificationCount = count;
  }
}
